import { ArrowBack, EditRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../../../layouts/main/main_layout";
import Loading from "../../../../components/loading/loading";
import { useFeedback } from "../../../../providers/feedback/feeedback";
import { RoleList } from "../../model/admin_roles";
import { getIndividualClientDetails, getRoles, modifyClient } from "../../../../services/client_mapping/client_mapping";
import { useQuery } from "react-query";
import { queryClient } from "../../../../providers/query/query";
import { ClientDetail } from "../../model/client_details";
import { client_mapping } from "../../../../routes/routes_path";
import { black, greyEnabled, purple, purpleLight } from "../../../../theme/colors";
export default function ModifyClient() {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState("");
  const [adminEmailId, setAdminEmailId] = useState("");
  const [adminRole, setAdminRole] = useState<{
    roleId: number;
    role: string;
  } | null>(null);
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { showSnackbar } = useFeedback();
  const { id } = useParams()


  const { data: details, isLoading: isDetailsLoading } = useQuery<ClientDetail>(
    ["modify-Client-Details", id],
    async () => {
      let { data } = await getIndividualClientDetails({ id: +id! });
      return data?.data;
    }
  );

  const { data: roleList, isLoading: isRoleListLoading } = useQuery(
    ["get-Roles", details?.orgId],
    async () => {
      let response = await getRoles({ page: 1, size: 100, module: 'all', keyword: '', orgId: details?.orgId });
      return response.data.data;
    },
    { enabled: !!details?.orgId }
  );

  const isPageLoading = isRoleListLoading || isDetailsLoading;

  const modifyAdminApiCall = () => {
    const regex = /[^a-zA-Z0-9 ]/;
    if (regex.test(adminName)) {
      showSnackbar("Special characters are not allowed for admin name");
    } else {
      setSubmitting(true);
      modifyClient({ clientEmailId: adminEmailId, clientName: adminName, moduleId: adminRole?.roleId!, clientId: +id! })
        .then((res) => {
          showSnackbar("Client Modified Successfully");
          queryClient.invalidateQueries({ queryKey: ["client-List"] });
          queryClient.invalidateQueries({ queryKey: ["individual-Client-Details"] });
          navigate(client_mapping)
        })
        .catch((e) => {
          if (e.response.status === 445 && e.response.data.error.code === 445) {
            showSnackbar("Client already exist !");
          } else if (
            e.response.status === 403 &&
            e.response.data.error.code === 403
          ) {
            showSnackbar("Client don't have permission");
          } else if (e?.response?.data?.error?.message) {
            showSnackbar(e?.response?.data?.error?.message);
          } else {
            showSnackbar("Something went wrong");
          }
        })
        .finally(() => setSubmitting(false));
    }
  };

  useEffect(() => {
    setAdminEmailId(details?.emailId || "");
    setAdminName(details?.clientName || "")
    setAdminRole({ roleId: details?.roleId!, role: details?.roleAssigned! })

  }, [details])

  const submitForm = () => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    if (emailRegex?.test(adminEmailId)) {
      modifyAdminApiCall?.();
    } else {
      setError(true);
    }
  };

  return (
    <MainLayout>
      <Box>
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: purpleLight,
                flexShrink: 0,
              }}
            >
              <EditRounded sx={{ color: purple, fontSize: 22 }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={700} color={black}>
                Modify Client
              </Typography>
              <Typography variant="body2" color={greyEnabled}>
                Update the client's details and assigned role.
              </Typography>
            </Box>
          </Box>
        </Box>

        <Card
          elevation={0}
          sx={{ width: '100%', maxWidth: 600, mt: 2, borderRadius: 3, border: '1px solid #ECECEC' }}
        >
          <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
            {isPageLoading ? (
              <Box display="flex" justifyContent="center" py={8}>
                <Loading />
              </Box>
            ) : (
            <Box display="flex" flexDirection="column">
                  <Box>
                    <TextField
                      fullWidth
                      label="Admin Name"
                      placeholder="Enter Admin name"
                      value={adminName}
                      onChange={(event) => {
                        if (event.target.value !== ' ')
                          setAdminName(event?.target.value);
                      }}
                      inputProps={{ maxLength: 40 }}
                      required
                    />
                  </Box>
                  <Box mt={3}>
                    <TextField
                      fullWidth
                      label="Email ID"
                      placeholder="Enter Email id"
                      value={adminEmailId}
                      onChange={(event) => {
                        if (event.target.value !== ' ') {
                          setAdminEmailId(event?.target.value.trim());
                        }
                        setError(false)
                      }}
                      required
                    />
                    {error && (
                      <FormHelperText sx={{ color: "red", m: 0 }}>
                        Please Enter valid Email
                      </FormHelperText>
                    )}
                  </Box>
                  <Box mt={3}>
                    <FormControl fullWidth>
                      <InputLabel id="role-label">
                        Select Role<span style={{ color: "#D14C2E" }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="role-label"
                        label="Select an Option"
                        fullWidth
                        placeholder="Select an Option"
                        value={adminRole?.role || ""}
                        onChange={(e) => {
                          const selectedRole = roleList?.list?.find(
                            (role: any) => role.role === e.target.value
                          );
                          if (selectedRole) {
                            setAdminRole({
                              roleId: selectedRole.id,
                              role: selectedRole.role,
                            });
                          }
                        }}
                        MenuProps={{
                          PaperProps: {
                            elevation: 0,
                            sx: {
                              mt: 0.5,
                              borderRadius: 2,
                              border: "1px solid #ECECEC",
                              boxShadow: "0px 12px 28px -8px rgba(27, 0, 27, 0.18)",
                            },
                          },
                        }}
                      >
                        {roleList?.list?.map((role: RoleList) => (
                          <MenuItem key={role.id} value={role.role} className={role.role}>
                            {role.role}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    mt={4}
                  >
                    <Button
                      onClick={() => navigate(-1)}
                      variant="outlined"
                      sx={{
                        borderColor: purple,
                        color: purple,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        minWidth: 150,
                        "&:hover": { borderColor: purple, bgcolor: purpleLight },
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      onClick={submitForm}
                      disabled={
                        submitting || !(adminName && adminRole)
                      }
                      variant="contained"
                      disableElevation
                      startIcon={submitting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
                      sx={{
                        minWidth: 150,
                        bgcolor: purple,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": { bgcolor: "#7A2074" },
                      }}
                    >
                      Modify Admin
                    </Button>
                  </Box>
            </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    </MainLayout>
  );
}
